import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeButtonSkeleton } from './TypeButton';
import type { TypeFormSkeleton } from './TypeForm';
import type { TypeNt_experienceSkeleton } from './TypeNt_experience';

export interface TypeCtaSimpleFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Symbol;
    paragraphText?: EntryFieldTypes.Text;
    button?: EntryFieldTypes.EntryLink<TypeButtonSkeleton>;
    form?: EntryFieldTypes.EntryLink<TypeFormSkeleton>;
    nt_experiences?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNt_experienceSkeleton>>;
}

export type TypeCtaSimpleSkeleton = EntrySkeletonType<TypeCtaSimpleFields, 'ctaSimple'>;
export type TypeCtaSimple<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeCtaSimpleSkeleton,
    Modifiers,
    Locales
>;

export function isTypeCtaSimple<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeCtaSimple<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'ctaSimple';
}
